
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.854 22.643l-4.978-4.979a9.967 9.967 0 10-16.7-8.986L.948 6.229a.5.5 0 00-.895.448l1.979 3.957a.488.488 0 00.8.211L6.724 8.9a.5.5 0 10-.447-.895L3.044 9.622a8.966 8.966 0 114.378 8.593.5.5 0 00-.508.861 9.948 9.948 0 0011.2-.755l5.029 5.029a.5.5 0 00.707-.707z"}})])
          )
        }
      }
    